module.exports = __webpack_public_path__ + "img/undraw_Hamburger.c2d14d7f.svg";